/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  Api2ResponseOfImageUpload,
  LikeCount,
  ResponseSlideDTO,
  ResponseSlideWithPaginationDTO,
  ResponseSlideWithUserInfoDTO,
  SlideCountDTO,
  SlidesCountByProductDTO,
  SlideViewCount,
  StateDTO,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Stories<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags admin-controller
   * @name GetLikedSlideCountGroupedByUserUsingGet
   * @summary Возвращает количество слайдов, сгруппированное по лайкнувшим пользователям
   * @request GET:/api/v1/stories/stats/slide/likedSlideCountGroupedByUser
   */
  getLikedSlideCountGroupedByUserUsingGet = (params: RequestParams = {}) =>
    this.request<SlideCountDTO[], void>({
      path: `/api/v1/stories/stats/slide/likedSlideCountGroupedByUser`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags admin-controller
   * @name GetSlideCountGroupedByUserUsingGet
   * @summary Возвращает количество слайдов, сгруппированное по авторам
   * @request GET:/api/v1/stories/stats/slide/slideCountGroupedByUser
   */
  getSlideCountGroupedByUserUsingGet = (params: RequestParams = {}) =>
    this.request<SlideCountDTO[], void>({
      path: `/api/v1/stories/stats/slide/slideCountGroupedByUser`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags main-controller
   * @name AddSlideUsingPost1
   * @summary Сохраняет слайд с тегами и стикерами и возвращает представление слайда
   * @request POST:/api/v1/stories/slide
   */
  addSlideUsingPost1 = (
    data: {
      /**
       * Фото или видео слайда
       * @format binary
       */
      content: File;
      /**
       * Данные слайда в формате json в файле с расширением .json. Пример {
       *   'title: 'Test',
       *   'slideType': 'USER',
       *   'statusType': 'ACTIVE',
       *   'tagDTOList': [
       *     {
       *       'contentURL': 'Test',
       *       'TagType': 'PRODUCT',
       *       'statusType': 'ACTIVE',
       *       'x': 56.56,
       *       'y': 56.56,
       *       'productId': 6565,
       *       'price': 787,
       *       'oldPrice': 9898
       *     }
       *   ],
       *   'stickerDTOList': [
       *     {
       *       'x': 65.65,
       *       'y': 65.65,
       *       'angle': 4545,
       *       'scale': 65.32,
       *       'stickerURL': 'Test',
       *       'emoji': '😀'
       *     }
       *   ]
       * }
       * @format binary
       */
      data: File;
    },
    params: RequestParams = {},
  ) =>
    this.request<ResponseSlideDTO, void>({
      path: `/api/v1/stories/slide`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags main-controller
   * @name GetSlidesByCatalogSearchCriteriaUsingGet
   * @summary Возвращает слайды, по критериям фильтрации в каталоге
   * @request GET:/api/v1/stories/slide/catalog
   */
  getSlidesByCatalogSearchCriteriaUsingGet = (
    query: {
      /**
       * Первичные ключи товаров
       * @format int64
       */
      productIds: number;
      /**
       * Номер страницы
       * @format int32
       */
      pageNumber: number;
      /**
       * Количество сторисов на странице
       * @format int32
       */
      pageSize: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<ResponseSlideWithPaginationDTO, void>({
      path: `/api/v1/stories/slide/catalog`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags main-controller
   * @name GetSlidesCountByProductsUsingGet
   * @summary Возвращает по продукту количество слайдов
   * @request GET:/api/v1/stories/slide/product/count
   */
  getSlidesCountByProductsUsingGet = (params: RequestParams = {}) =>
    this.request<SlidesCountByProductDTO[], void>({
      path: `/api/v1/stories/slide/product/count`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags main-controller
   * @name ChangeSlideStatusTypeUsingGet
   * @summary Смена статуса слайда
   * @request GET:/api/v1/stories/slide/status/{slideId}
   */
  changeSlideStatusTypeUsingGet = (
    slideId: string,
    query: {
      /** Тип на который хотим поменять текущий статус */
      statusType: "ACTIVE" | "ARCHIVE" | "DELETED" | "HIDDEN" | "SOLD" | "USER" | "WAITING";
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/v1/stories/slide/status/${slideId}`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags main-controller
   * @name GetUserAllSlideUsingGet
   * @summary Возвращает все слайды пользователя, для самого пользователя
   * @request GET:/api/v1/stories/slide/user/all
   */
  getUserAllSlideUsingGet = (
    query: {
      /**
       * Номер страницы
       * @format int32
       */
      pageNumber: number;
      /**
       * Количество сторисов на странице
       * @format int32
       */
      pageSize: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<ResponseSlideWithPaginationDTO, void>({
      path: `/api/v1/stories/slide/user/all`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags main-controller
   * @name UpdateUserViewStoryStateOnSeenUsingPost
   * @summary Обновление у пользователя сторис, что он просмотрен
   * @request POST:/api/v1/stories/slide/view/{storyId}
   */
  updateUserViewStoryStateOnSeenUsingPost = (storyId: string, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/v1/stories/slide/view/${storyId}`,
      method: "POST",
      ...params,
    });
  /**
   * No description
   *
   * @tags main-controller
   * @name UpdateUserViewSlideStateOnSeenUsingPost
   * @summary Обновление у пользователя слайда, что он просмотрен
   * @request POST:/api/v1/stories/slide/view/{storyId}/{slideId}
   */
  updateUserViewSlideStateOnSeenUsingPost = (storyId: string, slideId: string, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/v1/stories/slide/view/${storyId}/${slideId}`,
      method: "POST",
      ...params,
    });
  /**
   * No description
   *
   * @tags main-controller
   * @name FetWishListUsingGet
   * @summary Возвращает слайды, которые понравились пользователю
   * @request GET:/api/v1/stories/slide/wishlist
   */
  fetWishListUsingGet = (
    query: {
      /**
       * Номер страницы
       * @format int32
       */
      pageNumber: number;
      /**
       * Количество сторисов на странице
       * @format int32
       */
      pageSize: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<ResponseSlideWithPaginationDTO, void>({
      path: `/api/v1/stories/slide/wishlist`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags main-controller
   * @name GetSlideUsingGet
   * @summary Возвращает представление слайда по первичному ключу слайда
   * @request GET:/api/v1/stories/slide/{slideId}
   */
  getSlideUsingGet = (slideId: string, params: RequestParams = {}) =>
    this.request<ResponseSlideWithUserInfoDTO, void>({
      path: `/api/v1/stories/slide/${slideId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags main-controller
   * @name UpdateSlideUsingPut1
   * @summary Обновляет слайд с тегами и стикерами и возвращает представление слайда
   * @request PUT:/api/v1/stories/slide/{slideId}
   */
  updateSlideUsingPut1 = (
    slideId: string,
    data: {
      /**
       * Фото или видео слайда
       * @format binary
       */
      content: File;
      /**
       * Данные слайда в формате json в файле с расширением .json
       * @format binary
       */
      data: File;
    },
    params: RequestParams = {},
  ) =>
    this.request<ResponseSlideDTO, void>({
      path: `/api/v1/stories/slide/${slideId}`,
      method: "PUT",
      body: data,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags main-controller
   * @name DeleteSlideUsingDelete1
   * @summary Удаление слайда
   * @request DELETE:/api/v1/stories/slide/{slideId}
   */
  deleteSlideUsingDelete1 = (slideId: string, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/api/v1/stories/slide/${slideId}`,
      method: "DELETE",
      ...params,
    });
  /**
   * No description
   *
   * @tags main-controller
   * @name RemoveLikeUsingPost
   * @summary Удаление Лайка у слайду
   * @request POST:/api/v1/stories/slide/{slideId}/dislike
   */
  removeLikeUsingPost = (
    slideId: string,
    query: {
      /** Тип слайда */
      slideType: "ADV" | "INFO" | "SYSTEM" | "USER";
      /**
       * Первичный ключ пользователя кому поставили лайк
       * @format int64
       */
      userId: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/v1/stories/slide/${slideId}/dislike`,
      method: "POST",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags main-controller
   * @name GetSlideLikesCountUsingGet
   * @summary Получение количества лайков слайда
   * @request GET:/api/v1/stories/slide/{slideId}/like
   */
  getSlideLikesCountUsingGet = (slideId: string, params: RequestParams = {}) =>
    this.request<LikeCount, void>({
      path: `/api/v1/stories/slide/${slideId}/like`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags main-controller
   * @name AddLikeUsingPost
   * @summary Добавление Лайка к слайду
   * @request POST:/api/v1/stories/slide/{slideId}/like
   */
  addLikeUsingPost = (
    slideId: string,
    query: {
      /** Тип слайда */
      slideType: "ADV" | "INFO" | "SYSTEM" | "USER";
      /**
       * Первичный ключ пользователя кому поставили лайк
       * @format int64
       */
      userId: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/v1/stories/slide/${slideId}/like`,
      method: "POST",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags main-controller
   * @name GetSlideViewCountUsingGet
   * @summary Получение количества просмотров слайда
   * @request GET:/api/v1/stories/slide/{slideId}/view
   */
  getSlideViewCountUsingGet = (slideId: string, params: RequestParams = {}) =>
    this.request<SlideViewCount, void>({
      path: `/api/v1/stories/slide/${slideId}/view`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags main-controller
   * @name GetUserAllSlidesForOtherUserUsingGet
   * @summary Возвращает все слайды пользователя, для других пользователей
   * @request GET:/api/v1/stories/slide/{userId}/all
   */
  getUserAllSlidesForOtherUserUsingGet = (
    userId: number,
    query: {
      /**
       * Номер страницы
       * @format int32
       */
      pageNumber: number;
      /**
       * Количество сторисов на странице
       * @format int32
       */
      pageSize: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<ResponseSlideWithPaginationDTO, void>({
      path: `/api/v1/stories/slide/${userId}/all`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags main-controller
   * @name GetStickersPathsUsingGet1
   * @summary Получение списка путей стикеров
   * @request GET:/api/v1/stories/stickers
   */
  getStickersPathsUsingGet1 = (params: RequestParams = {}) =>
    this.request<Api2ResponseOfImageUpload, void>({
      path: `/api/v1/stories/stickers`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags main-controller
   * @name GetStoriesByUserViewStateUsingGet
   * @summary Получение сторисов по данным конкретного пользователя
   * @request GET:/api/v1/stories/story
   */
  getStoriesByUserViewStateUsingGet = (
    query: {
      /**
       * Номер страницы
       * @format int32
       */
      pageNumber: number;
      /**
       * Количество сторисов на странице
       * @format int32
       */
      pageSize: number;
      /** Флаг для проверки обновлять сторисы или получить обновленный список */
      isUpdate: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<StateDTO, void>({
      path: `/api/v1/stories/story`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags main-controller
   * @name GetStoriesByUserViewStateNewPageUsingGet
   * @summary Получение сторисов по данным конкретного пользователя для новой главной страницы
   * @request GET:/api/v1/stories/story/new
   */
  getStoriesByUserViewStateNewPageUsingGet = (
    query: {
      /** С какого сториса надо отдать данные */
      anchor?: string;
      /**
       * Сколько сторисов надо отдать
       * @format int32
       */
      count: number;
      /** Выбранные пользователи */
      selectedIds?: string;
      /** Отключение ленты */
      disableFeed?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<StateDTO, void>({
      path: `/api/v1/stories/story/new`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags main-controller
   * @name GetStoriesAllDataByUserViewStateNewPageUsingGet
   * @summary Получение сторисов со слайдами по данным конкретного пользователя для новой главной страницы
   * @request GET:/api/v1/stories/story/primary
   */
  getStoriesAllDataByUserViewStateNewPageUsingGet = (
    query: {
      /** С какого сториса надо отдать данные */
      anchor?: string;
      /**
       * Сколько сторисов надо отдать
       * @format int32
       */
      nextCount: number;
      /** Выбранные пользователи */
      selectedIds?: string;
      /** Отключение ленты */
      disableFeed?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<StateDTO, void>({
      path: `/api/v1/stories/story/primary`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
}
